import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const RadioHeartSelect = ({
  size = 16,
  title = 'Select',
  fill = colors.taosSky,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 30 28.185">
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M61.972,138.334l-2.69-2.443c-1.166-1.059-2.335-2.12-3.493-3.191a58.928,58.928,
0,0,1-4.76-4.824,21.275,21.275,0,0,1-2.665-3.763,11.4,11.4,0,0,
1-1.25-3.615c-.05-.308-.093-.636-.113-.964l0-1.19.033-.144a8.336,8.336,0,0,1,
.529-2.355,8.585,8.585,0,0,1,
7.083-5.611c.241-.034.528-.055.8-.076l.59-.009c.409.026.695.048.98.088a9.468,
9.468,0,0,1,5,2.266l.187-.163a9.2,9.2,0,0,1,4.8-2.089c.272-.038.569-.06.866-.081l.633,
0,.2.033c.193.028.354.045.516.064a8.543,8.543,0,0,1,7.65,7.255L77,118.537l-.036,
1.272a10.942,10.942,0,0,1-.823,3.308,17.827,17.827,0,0,1-2.68,4.217,39.866,39.866,
0,0,1-3.622,3.856q-3.326,3.012-6.591,6.02c-.086.088-.23.215-.375.34Z
`}
        transform="translate(-46.997 -110.15)"
        fill={fill}
      />
    </svg>
  );
};
